// AI-CONTEXT: See docs/features/impact-in-beeld-fase2.md

/**
 * Openingszin van de publieke productpagina: de eigen openingszin van het
 * product, of het default-template met alleen de productnaam (nette degradatie
 * — een product zonder eigen content erft de org-laag).
 *
 * @param {{Name: string, OpeningLine?: string}} product
 * @returns {string} de te tonen openingszin
 */
const resolveProductOpening = (product) => {
    const own = (product?.OpeningLine || '').trim()
    if (own) return own

    return `Met jouw aankoop van ${product.Name} draag je bij aan onze maatschappelijke impact.`
}

export { resolveProductOpening }
